import { MprcButton, MprcButtonProps } from "components/MprcButton";
import * as React from "react";
import { useMprcTheme } from "../MprcThemeProvider";

export const ButtonApply: React.FC<MprcButtonProps> = ({ text, title, ...rest }) => {
    const { theme } = useMprcTheme();
    const lText = text || theme.buttons.ButtonApply.text;
    const lTitle = title || theme.buttons.ButtonApply.title;

    return (
        <MprcButton
            {...rest}
            title={lTitle}
            text={lText}
        />
    );
};
